import crypto from "crypto-js";

const PROXY_API_URL =
  "https://oco3clugig.execute-api.eu-west-1.amazonaws.com/prod";

export const createLimit = (concurrency) => {
  let activeCount = 0;
  const queue = [];

  const next = () => {
    if (queue.length > 0 && activeCount < concurrency) {
      activeCount++;
      const { fn, resolve, reject } = queue.shift();
      fn()
        .then(resolve)
        .catch(reject)
        .finally(() => {
          activeCount--;
          next();
        });
    }
  };

  const limit = (fn) => {
    return new Promise((resolve, reject) => {
      queue.push({ fn, resolve, reject });
      next();
    });
  };

  return limit;
};

function generateAuthHeaders() {
  const timestamp = Date.now().toString();
  const payload = `${timestamp}`;
  const signature = crypto
    .HmacSHA256(payload, process.env.REACT_APP_PROXY_API_SHARED_SECRET || "")
    .toString(crypto.enc.Hex);

  return {
    "x-s": signature,
    "x-t": timestamp,
  };
}

export const fetchWithAuth = (url, options = {}) => {
  const headers = generateAuthHeaders();

  return fetch(`${PROXY_API_URL}/${url}`, {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  });
};
